"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var CleanIcon_1 = __importDefault(require("./CleanIcon"));
var SearchIcon_1 = __importDefault(require("./SearchIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Search = function (_a) {
    var onClean = _a.onClean, value = _a.value, onChange = _a.onChange;
    var t = (0, next_intl_1.useTranslations)('translation');
    var searchInputRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("input", { ref: searchInputRef, className: styles_module_scss_1.default.input, type: "text", value: value, onChange: onChange, placeholder: t('search') }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.searchIcon, onClick: onClean },
            react_1.default.createElement(SearchIcon_1.default, null)),
        value && (react_1.default.createElement("div", { className: styles_module_scss_1.default.trashIcon, onClick: onClean },
            react_1.default.createElement(CleanIcon_1.default, null)))));
};
exports.default = Search;
